import useHttpLoader from 'shared/hooks/useHttpLoader'
import useProjectRolesState from '../projectRoles.atom'
import projectRolesApi, { IGetProjectRolesParams } from '../projectRoles.api'
import useSkipFirstRenderEffect from 'shared/hooks/useSkipFirstRenderEffect'
import { useRecoilValue } from 'recoil'
import projectRolesSelectors from '../projectRoles.selectors'

const useProjectRoles = () => {
  const [projectRolesState, setProjectRolesState] = useProjectRolesState()

  const projectRolesMap = useRecoilValue(projectRolesSelectors.projectRolesMap);
  const { wait, loading } = useHttpLoader()

  /* ------------------------- Загрузка ролей ----------------------- */

  const getProjectRoles = (reload?: boolean) => {
    // нужен селектор, поэтому пытаюсь загрузить все роли, вряд ли их будет больше тысячи
    const params: IGetProjectRolesParams = { nextPage: null, limit: 1000 }
    if (projectRolesState.nextPage && !reload) params.nextPage = projectRolesState.nextPage
    return projectRolesApi.getList(params)
  }

  useSkipFirstRenderEffect(() => {
    wait(getProjectRoles(true), (resp) => {
      if (resp.status === 'success') {
        setProjectRolesState((prev) => ({
          ...prev,
          nextPage: resp.body.nextPage,
          items: resp.body.items,
          totalCount: resp.body.totalCount,
        }))
      }
    })
  }, [])

  const loadMore = () => {
    getProjectRoles().then((r) => {
      if (r.status === 'success') {
        setProjectRolesState((prev) => ({
          ...prev,
          nextPage: r.body.nextPage,
          totalCount: r.body.totalCount,
          items: [...prev.items, ...r.body.items],
        }))
      }
    })
  }

  return { loadMore, projectRolesState, setProjectRolesState, loading, projectRolesMap }
}

export default useProjectRoles
